// extracted by mini-css-extract-plugin
export var fadeInOut = "_4m-3";
export var icon = "_4m-4";
export var savedIndicator = "_4m-2";
export var savingIndicator = "_4m-0";
export var spin = "_4m-1";